import React from 'react';
import PropTypes from 'prop-types';
import { Paper, IconButton, Grow, Link } from '@mui/material';

const FilePaper = function FilePaper({
  fileName,
  extensionIcon,
  onClick,
  onClickIcon,
  type,
}) {
  return (
    <Grow in>
      <Paper square elevation={3} sx={{ width: '10vw' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '8px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 3,
              overflow: 'hidden',
            }}
          >
            {extensionIcon}
            <Link
              // href={path}
              onClick={() => {
                const method = type === 'pdf' ? 'preview' : 'download';
                onClick(fileName, method);
              }}
              underline="hover"
              variant="body1"
              noWrap
              sx={{
                textOverflow: 'ellipsis',
                cursor: 'pointer',
              }}
            >
              {fileName}
            </Link>
          </div>
          <IconButton onClick={() => onClick(fileName, 'download')}>
            {onClickIcon}
          </IconButton>
        </div>
      </Paper>
    </Grow>
  );
};

FilePaper.propTypes = {
  fileName: PropTypes.string.isRequired,
  extensionIcon: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onClickIcon: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default FilePaper;
